import React from "react";

type PaymentStatusLayoutProps = {
  children: React.ReactNode;
};

export default function PaymentStatusLayout({ children }: PaymentStatusLayoutProps) {
  return (
    <section className="relative min-h-screen overflow-hidden bg-gradient-to-br from-bg-light-blue via-white to-background-grey flex items-center justify-center px-4 py-12 sm:px-6">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-20 right-[-4rem] h-64 w-64 rounded-full bg-bright-green/25 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-24 left-[-5rem] h-72 w-72 rounded-full bg-brand-blue/15 blur-3xl"
      />
      <div className="relative w-full max-w-[500px] rounded-[24px] border border-border-grey/70 bg-white px-8 py-12 text-center font-primary shadow-[0_24px_64px_rgba(17,15,42,0.08)] sm:px-12 sm:py-14">
        {children}
      </div>
    </section>
  );
}
